export const ErrorMessages = {
  isinError: 'ISIN not found',
  fundNotAvailable: 'Fund details not available',
  isinGraphError: 'ISIN not found in database!',
  netWorkError: 'Unable to load data, try a different network!',
};
